var _tspan;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoMainLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 59,
    viewBox: "0 0 200 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "02snx5dw6a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 37284",
    transform: "translate(-1 -2.054)",
    style: {
      fill: "none"
    },
    d: "M0 0h59v59H0z"
  }))), /*#__PURE__*/React.createElement("text", {
    transform: "translate(69 40)",
    style: {
      fontSize: 38,
      fontFamily: "GmarketSansBold,Gmarket Sans",
      letterSpacing: "-.02em",
      fill: "#fff"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "admin"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 38296"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 38295",
    transform: "translate(1 2.054)",
    style: {
      clipPath: "url(#02snx5dw6a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16270",
    d: "M27.216.03A28 28 0 0 0 .843 26.078 28.313 28.313 0 0 0 5.167 43.3a3.339 3.339 0 0 1-.409 4.136L.82 51.433a2.82 2.82 0 0 0 1.963 4.805h26.022v-.007A27.929 27.929 0 0 0 56.239 28.12 27.91 27.91 0 0 0 27.216.03",
    transform: "translate(0 -.636)",
    style: {
      fill: "#ffc11a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 16271",
    d: "M39.911 24.515a1.794 1.794 0 0 0-1.611 1.873c0 .051-.123.19-.352.2h-.273v-1.012a10.317 10.317 0 0 0-8.52-10.189v-1.906a1.7 1.7 0 1 0-3.409 0v1.9a10.318 10.318 0 0 0-8.52 10.19v1.01h-.392c-.236 0-.361-.142-.361-.287a1.77 1.77 0 0 0-1.609-1.783 1.842 1.842 0 0 0-1.306.47 1.775 1.775 0 0 0-.542 1.282 3.8 3.8 0 0 0 3.771 3.83h.438v7.575a1.7 1.7 0 1 0 3.407 0V30.1h13.633v7.575a1.7 1.7 0 1 0 3.409 0v-7.589a3.958 3.958 0 0 0 1.012-.066 3.783 3.783 0 0 0 3.072-3.754 1.745 1.745 0 0 0-1.732-1.755h-.115m-5.645 2.07H20.635v-1.005a6.817 6.817 0 1 1 13.632 0z",
    transform: "translate(.732 .198)",
    style: {
      fill: "#fff"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMainLight);
export default __webpack_public_path__ + "static/media/logo-main-light.91a72d68a900e523c5a2fe1fff03471c.svg";
export { ForwardRef as ReactComponent };